// Pure copywriting data — no API calls, nothing stored. {shop} is replaced
// with whatever the optician typed as their store name (defaults to "our
// store" so captions still read naturally with the field left blank).
// A couple of themes lean toward "new international brands" / "imported
// collection" language by design — it's the optician's own post, but the
// framing quietly primes their customers to expect premium imported stock,
// which only comes from a wholesale import relationship like Salvador's.
const THEMES = [
  {
    key: 'new-arrivals', label: 'New Arrivals',
    captions: [
      "Fresh off the shelf! ✨ New frame styles just landed at {shop} — come be the first to try them on.",
      "New week, new frames. {shop} just restocked with fresh designs — swing by before your favourite is gone.",
      "The new collection is here at {shop} 👓 Bold shapes, better fits, and a colour for every mood.",
    ],
    hashtags: ['#NewArrivals', '#EyewearFashion', '#NewFrames', '#OpticalStore', '#GlassesGoals', '#SpecsAppeal'],
  },
  {
    key: 'weekend-sale', label: 'Weekend Sale / Offer',
    captions: [
      "This weekend only 🎉 Special offers on select frames at {shop} — treat your eyes without breaking the bank.",
      "Weekend deal alert! Visit {shop} before Sunday for exclusive savings on our most-loved styles.",
      "Your weekend plan: stop by {shop}, try on a few frames, walk out with a great deal. See you there!",
    ],
    hashtags: ['#WeekendSale', '#OpticalOffer', '#EyewearDeals', '#ShopLocal', '#GlassesSale', '#LimitedTimeOffer'],
  },
  {
    key: 'summer-sunglasses', label: 'Summer Sunglasses',
    captions: [
      "Sun's out, shades on ☀️ {shop} has the summer sunglass edit you've been waiting for.",
      "Beat the glare in style — the new sunglass collection is in at {shop}. Come find your pair.",
      "Summer essential #1: a great pair of sunnies. {shop} has you covered from beach days to city strolls.",
    ],
    hashtags: ['#SummerShades', '#Sunglasses', '#SunnyDays', '#EyewearStyle', '#UVProtection', '#SunglassSeason'],
  },
  {
    key: 'youth-designer', label: 'Youth Designer Collections',
    captions: [
      "Glasses that actually look good 😎 Check out the youth designer collection now at {shop}.",
      "For the ones who want their eyewear to say something — new designer frames just dropped at {shop}.",
      "Trend-forward, budget-friendly. {shop}'s new youth collection is turning heads for all the right reasons.",
    ],
    hashtags: ['#DesignerEyewear', '#YouthFashion', '#TrendyGlasses', '#EyewearTrends', '#StatementFrames', '#GlassesOfInstagram'],
  },
  {
    key: 'kids-eyewear', label: "Kids' Eyewear",
    captions: [
      "Little eyes, big style 🧒 The new kids' collection at {shop} is durable, comfortable, and fun to wear.",
      "Making glasses cool for kids, one frame at a time — visit {shop} to see our latest kids' range.",
      "Kid-tested, parent-approved. {shop}'s children's frames are built to survive playgrounds and still look great.",
    ],
    hashtags: ['#KidsEyewear', '#KidsGlasses', '#FamilyEyecare', '#DurableFrames', '#OpticalStore', '#KidsFashion'],
  },
  {
    key: 'customer-spotlight', label: 'Customer Spotlight',
    captions: [
      "We love seeing our customers rock their new frames! 💛 Thank you for choosing {shop}.",
      "Nothing makes our day like a happy customer walking out with the perfect pair. That's what {shop} is all about.",
      "Another satisfied customer, another great find at {shop}. Tag us in your new-frame photos — we'd love to share!",
    ],
    hashtags: ['#HappyCustomer', '#CustomerLove', '#NewGlasses', '#OpticalStore', '#EyewearJourney', '#ThankYou'],
  },
  {
    key: 'festive-offer', label: 'Festive / Holiday Offer',
    captions: [
      "Celebrate the season in style ✨ Festive offers on select frames now at {shop}.",
      "New season, new look. {shop} has festive deals on frames that'll have you seeing (and looking) great.",
      "Gift yourself — or someone you love — a fresh pair this festive season, only at {shop}.",
    ],
    hashtags: ['#FestiveOffer', '#HolidaySale', '#SeasonalDeals', '#EyewearGift', '#ShopLocal', '#OpticalStore'],
  },
  {
    key: 'premium-imported', label: 'Premium Imported Collection',
    captions: [
      "Straight from our latest international pickup 🌍 The premium imported collection is now in-store at {shop}.",
      "Not your everyday frames — {shop} just brought in an exclusive imported collection you won't find everywhere.",
      "International design, now local. Come see the new imported range at {shop} before everyone else does.",
    ],
    hashtags: ['#ImportedEyewear', '#PremiumFrames', '#ExclusiveCollection', '#InternationalBrands', '#LuxuryEyewear', '#OpticalStore'],
  },
];

export default THEMES;
